module.exports = __webpack_public_path__ + "static/media/wallet-carret.56c2b451.svg";